module.exports = __webpack_public_path__ + "static/media/12-spotted-dragonfly-1.0e3a0222.jpg";